var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaidVmiSodraTaxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7344 42.5781H47.5781V39.6094H45.2344V22.5H47.5781V19.5312H50L25 0.3125L0 19.4531H2.5V22.4219H4.84375V39.5312H2.5V42.5H2.26562C1.09375 42.5 0.15625 43.4375 0.15625 44.6094V49.6875H49.6875V44.6094C49.7656 43.5156 48.8281 42.5781 47.7344 42.5781ZM46.4062 40.7031V42.5781H38.5156V40.7031H39.6875H45.2344H46.4062ZM27.8125 39.6094V22.5H30.1562V19.5312H37.4219V22.5H39.7656V39.6094H37.4219V42.5781H30.1562V39.6094H27.8125ZM10.3125 39.6094V22.5H12.6563V19.5312H19.9219V22.5H22.2656V39.6094H19.9219V42.5781H12.6563V39.6094H10.3125ZM22.1875 21.3281H21.0156V19.4531H28.9062V21.3281H27.7344H22.1875ZM26.6406 22.5V39.6094H23.3594V22.5H26.6406ZM21.0156 40.7031H22.1875H27.7344H28.9062V42.5781H21.0156V40.7031ZM40.7812 39.6094V22.5H44.0625V39.6094H40.7812ZM46.4062 21.3281H45.2344H39.6875H38.5156V19.4531H46.4062V21.3281ZM25 1.71875L46.6406 18.3594H3.35938L25 1.71875ZM3.59375 21.3281V19.4531H11.4844V21.3281H10.3125H4.76562H3.59375ZM9.21875 22.5V39.6094H5.9375V22.5H9.21875ZM3.59375 40.7031H4.76562H10.3125H11.4844V42.5781H3.59375V40.7031ZM48.6719 48.5938H1.32812V44.6875C1.32812 44.1406 1.71875 43.75 2.26562 43.75H2.42188H47.5H47.6562C48.2031 43.75 48.5938 44.1406 48.5938 44.6875V48.5938H48.6719Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1875 14.4531H12.8125V15.625H37.1875V14.4531Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 11.5625H19.5312V12.7344H30.4688V11.5625Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidVmiSodraTaxes);
export default __webpack_public_path__ + "static/media/paidVmiSodraTaxes.4a24e164583b6d3da56cca84b49ad189.svg";
export { ForwardRef as ReactComponent };